export default __webpack_public_path__ + "static/media/litho-demo-interactive-portfolio.cc4afbd9.jpg";